import styled from "styled-components";

import { ReactComponent as IndicioBankingLogoSVG } from "../assets/indicio-banking-logo.svg";
import { ReactComponent as CheckMarkShieldSVG } from "../assets/check-mark-shield.svg";

import { ReactComponent as HeraldicPeopleSVG } from "../assets/heraldic-people-verified.svg";

export const VerifiedSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 1150px;
    margin-bottom: clamp(4.2rem, 8vh, 6rem);

    @media (min-width: 1800px) {
      width: 1300px;
    }
    @media (max-width: 1200px) {
      width: 100%;
      padding: 0 2rem;
    }

    > span {
      width: 12%;
      display: block;
      margin-bottom: 1.6rem;
    }

    > div {
      width: 100%;
    }
    > div:nth-of-type(2) {
      display: grid;
      grid-auto-flow: column;
      grid-auto-columns: 0.4fr 1fr 1fr 1fr;
      gap: 1.5rem;

      > span {
        align-self: end;
      }
    }
  }
`;

export const VerifiedText = styled.div`
  margin-bottom: clamp(4rem, 8vh, 5rem);

  h1 {
    margin: 0 0 1.2rem 0;
    font-size: 2.2rem;
    width: 100%;
    white-space: nowrap;

    span {
      color: #40ad50;
    }
  }

  p {
    font-size: 0.8rem;
  }
  p:nth-of-type(1) {
    margin-bottom: 1rem;
  }
  p:nth-of-type(2) {
    font-weight: 700;
    margin-bottom: 0;

    u {
      color: ${(props) => props.theme.primaryPurple};
    }
  }
`;

export const VerifiedOptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 1.4rem 1rem 1rem 1rem;
  border-radius: 10px;
  background-color: ${(props) => props.theme.regWhite};
  filter: drop-shadow(0px 0px 10px rgba(86, 86, 76, 0.5));
  min-width: 0;

  button {
    width: 100%;
    height: 4rem;
    background-color: ${(props) => props.theme.primaryPurple};
    color: ${(props) => props.theme.regWhite};
    border-radius: 10px;
    border: none;
    font-size: 1.2rem;
    font-weight: 700;
    text-transform: uppercase;
  }
`;

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;

  > h4 {
    margin: 0 0 0.5rem 0;
  }
  > p {
    white-space: nowrap;
    font-size: 0.7rem;
    color: ${(props) => props.theme.darkGray};
  }
  > div:nth-of-type(1) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;

    p {
      text-decoration: line-through;
      color: ${(props) => props.theme.darkGray};
      margin-right: 10px;
    }
    h4 {
      font-size: 2.5rem;
      margin: 0;

      span {
        font-size: 1rem;
        font-weight: 500;
      }
    }
  }
  > div:nth-of-type(2) {
    h6 {
      color: ${(props) => props.theme.darkGray};
      margin: 0 0 0.7rem 0;
    }

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      font-size: 0.7rem;

      li {
        margin: 0 0 0.7rem 0;
        padding: 0;
        display: flex;
        align-items: center;

        span {
          margin-right: 10px;
        }
      }
    }
  }
`;
export const IndicioBankingLogo = styled(IndicioBankingLogoSVG)`
  width: 100%;
  height: auto;
  display: block;
`;
export const CheckMarkShield = styled(CheckMarkShieldSVG)`
  width: auto;
  height: 100%;
  display: block;
`;

export const HeraldicPeopleVerified = styled(HeraldicPeopleSVG)`
  width: 100%;
  height: auto;
  display: block;
`;
